// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"07981a03","295":"d9dec8e5","453":"3ad81ea3"}[chunkId] + ".chunk.js";
};